import { NotificationMessageDto } from "@/modules/types/notification/notification";
import { apiClient, ApiClient } from "@/lib/api/api-client";
import { BaseResponse } from "@/modules/types/response";

export interface NotificationResponse extends BaseResponse {
  notifications: NotificationMessageDto[];
  total: number;
  nextId: string;
}

export class NotificationService {
  private BASE_PATH =
    process.env.API_NOTIFICATION_ENDPOINT ||
    "http://localhost:8004/notification";
  private apiClient: ApiClient = apiClient;
  private apiVersion = "v1.0.0";
  constructor(apiVersion?: string) {
    this.apiVersion = apiVersion || this.apiVersion;
  }

  async getNotifications(
    businessId: string,
    page?: number,
    limit?: number,
    isRead?: boolean,
    isSeen?: boolean,
    nextId?: string
  ): Promise<NotificationResponse> {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page.toString());
    if (limit) queryParams.append("limit", limit.toString());
    if (isRead !== undefined) queryParams.append("isRead", isRead.toString());
    if (isSeen !== undefined) queryParams.append("isSeen", isSeen.toString());
    if (businessId) queryParams.append("businessId", businessId);
    if (nextId) queryParams.append("nextId", nextId);
    return await this.apiClient.fetch<NotificationResponse>(
      `${this.BASE_PATH}/${
        this.apiVersion
      }/business/list?${queryParams.toString()}`
    );
  }

  async seenNotification(businessId: string, notiId: string) {
    return await this.apiClient.fetch<BaseResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/seen?businessId=${businessId}&notificationId=${notiId}`,
      {
        method: "POST",
      }
    );
  }
}
